export default __webpack_public_path__ + "static/media/behance.a8d8d408.png";